var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoSmallBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 28,
  fill: "none",
  viewBox: "0 0 832 576"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipPath: "url(#logo-small-blue_svg__a)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0D375A",
  d: "M212.313 576C319.092 447.722 526.84 289.134 831.051 274.241H832C417.334 271.973 108.558 463.72 0 576z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0D375A",
  d: "M439.686 576C494.113 479.544 634.153 285.237 832 274.183 557.611 287.622 347.255 433.003 235.317 576z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F04E4C",
  d: "m237.273 399.261 11.325-19.256 116.561-198.147 76.246 129.558 3.794 6.399a1334 1334 0 0 1 92.965-23.91 1336 1336 0 0 1 177.096-26.587c-53.064-1.512-121.305 2.327-183.855 15.01l-6.581-11.228L365.159 0 195.712 287.971 91.66 464.768l-20.573 34.963c51.048-37.989 107.135-71.149 163.934-99.422.77-.349 1.482-.757 2.252-1.106M541.959 482.395 597.038 576h107.017l-99.487-169.059c49.625-51.37 109.151-94.187 177.926-114.491-69.902 15.65-132.096 54.279-185.159 102.099-15.593 14.079-30.415 28.914-44.408 44.214-7.47 8.203-14.763 16.522-21.877 25.074l3.557 5.992 7.352 12.508z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-small-blue_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h832v576H0z"
})))));
export default SvgLogoSmallBlue;